export const formatNumber = (value) => (
  Number.isFinite(value) ? Math.round(value).toLocaleString() : '--'
);

export const formatDecimal = (value) => (
  Number.isFinite(value) ? value.toFixed(3) : '--'
);

export const formatPValue = (value) => (
  Number.isFinite(value) ? value.toFixed(3) : '--'
);

export const formatPercent = (value) => (
  Number.isFinite(value) ? `${(value * 100).toFixed(1)}%` : '--'
);

export const formatCI = (ci) => {
  if (!ci || !Number.isFinite(ci.lower) || !Number.isFinite(ci.upper)) return '--';
  return `${Math.round(ci.lower).toLocaleString()} - ${Math.round(ci.upper).toLocaleString()}`;
};

export const formatDeltaWithPercent = (delta, base) => {
  if (!Number.isFinite(delta)) return '--';
  const sign = delta > 0 ? '+' : '';
  if (!Number.isFinite(base) || base === 0) return `${sign}${formatNumber(delta)}`;
  const percent = (delta / base) * 100;
  const percentSign = percent > 0 ? '+' : '';
  return `${sign}${formatNumber(delta)} (${percentSign}${percent.toFixed(1)}%)`;
};

export const formatTooltipValue = (value) => {
  if (Array.isArray(value)) {
    const [lower, upper] = value;
    if (!Number.isFinite(lower) || !Number.isFinite(upper)) return '--';
    return `${formatNumber(lower)} - ${formatNumber(upper)}`;
  }
  return formatNumber(value);
};

export const formatDate = (value) => {
  if (!value) return '--';
  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '--';
    const spaceIndex = trimmed.indexOf(' ');
    return spaceIndex > 0 ? trimmed.slice(0, spaceIndex) : trimmed;
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return String(value);
  return parsed.toISOString().slice(0, 10);
};
